import {Fill, Stroke, Style, Text} from "ol/style";
import Circle from "ol/style/Circle";


export const asfBlueZoneStyle = (style) => {
    return [style, new Style({
        stroke: new Stroke({
            color: '#0C62F2',
            lineDash: [4],
            width: 2,
            lineJoin: "bevel",
        }),
        fill: new Fill({
            color: 'rgba(227, 229, 231, 0)',
        }),
    })];
}

export const asfRedZoneStyle = (style) => {
    return [style, new Style({
        stroke: new Stroke({
            color: 'rgb(188, 0, 3)',
            lineDash: [4],
            width: 2,
            lineJoin: "bevel",
        }),
        fill: new Fill({
            color: 'rgba(227, 229, 231, 0)',
        }),
    })];
}

export const asfYellowZoneStyle = (style) => {
    return [style, new Style({
        stroke: new Stroke({
            color: 'rgb(246, 242, 18)',
            lineDash: [4],
            width: 2,
            lineJoin: "bevel",
        }),
        fill: new Fill({
            color: 'rgba(227, 229, 231, 0)',
        }),
    })];
}

export const adminShutdownZoneStyle = (style) => {
    return [style, new Style({
        stroke: new Stroke({
            color: 'black',
            width: 1,
            lineJoin: "bevel",
        }),
        fill: new Fill({
            color: patternAdminShutdown,
        }),
    })];
}

export const differentShutdownZoneStyle = (style) => {
    return [style, new Style({
        stroke: new Stroke({
            color: 'rgb(220, 160, 9)',
            lineDash: [4],
            width: 2,
            lineJoin: "bevel",
        }),
        fill: new Fill({
            color: 'rgba(227, 229, 231, 0)',
        }),
    })];
}

export const partReserveZoneStyle = (style) => {
    return [style, new Style({
        stroke: new Stroke({
            color: 'rgb(63, 138, 19)',
            width: 2,
            lineJoin: "bevel",
        }),
        fill: new Fill({
            color: patternPartReserve,
        }),
    })];
}

export const fullReserveZoneStyle = (style) => {
    return [style, new Style({
        stroke: new Stroke({
            color: 'rgb(63, 138, 19)',
            width: 2,
            lineJoin: "bevel",
        }),
        fill: new Fill({
            color: patternFullReserve,
        }),
    })];
}

export const zonesStyle = (feature) => {

    let style = new Style({
        stroke: new Stroke({
            color: 'rgba(0, 0, 0, 0)'
        }),
        fill: new Fill({
            color: 'rgba(255, 255, 255, 0)',
        }),
        text: new Text({
            textAlign: 'center',
            textBaseline: 'middle',
            text: feature.get('name'),
            fill: new Fill({color: 'white'}),
            stroke: new Stroke({color: 'black', width: 2}),
            placement: 'point',
            font: '12px sans-serif',
            overflow: false,
        }),
    })

    let data = feature.get('type');

    if(data === 'zone'){
        data = feature.get('zone-data').zone_type_id;
    }

    if (data) {
        data = parseInt(data);
        switch (data) {
            case 1:
                return asfBlueZoneStyle(style, feature);
            case 2:
                return asfRedZoneStyle(style, feature);
            case 3:
                return asfYellowZoneStyle(style, feature);
            case 4:
                return fullReserveZoneStyle(style, feature);
            case 5:
                return partReserveZoneStyle(style, feature);
            case 6:
                return adminShutdownZoneStyle(style, feature);
            case 7:
                return differentShutdownZoneStyle(style, feature);
        }

    }

    return style;
}


export const drawZonesStyle = new Style({
    image: new Circle({
        fill: new Fill({
            color: 'rgba(117, 117, 117, 0.75)'
        }),
        stroke: new Stroke({
            color: 'rgba(0, 0, 0, 1)'
        }),
        radius: 5
    }),
    stroke: new Stroke({
        color: 'rgba(0, 0, 0, 1)',
        lineDash: [4],
        width: 1,
        lineJoin: "bevel",
    }),
    fill: new Fill({
        color: 'rgba(117, 117, 117, 0.75)'
    })
});

const canvasFullReserve = document.createElement('canvas');
const contextFullReserve = canvasFullReserve.getContext('2d');
const canvasPartReserve = document.createElement('canvas');
const contextPartReserve = canvasPartReserve.getContext('2d');
const canvasAdminShutdown = document.createElement('canvas');
const contextAdminShutdown = canvasAdminShutdown.getContext('2d');

const patternFullReserve = (function () {

    let color1 = "rgba(25, 153, 21, 1)", color2 = "rgba(0,0,0,0)";
    let numberOfStripes = 40;
    for (let i = 0; i < numberOfStripes * 2; i++) {
        let thickness = 300 / numberOfStripes;
        contextFullReserve.beginPath();
        contextFullReserve.strokeStyle = i % 2 ? color1 : color2;
        contextFullReserve.lineWidth = 1;
        contextFullReserve.lineCap = 'round';

        contextFullReserve.moveTo(i * thickness + thickness / 2 - 300, 0);
        contextFullReserve.lineTo( i * thickness + thickness / 2, 300);
        contextFullReserve.stroke();
    }

    for (let i = 0; i < numberOfStripes * 2; i++) {
        let thickness = 300 / numberOfStripes;
        contextFullReserve.beginPath();
        contextFullReserve.strokeStyle = i % 2 ? color1 : color2;
        contextFullReserve.lineWidth = 1;
        contextFullReserve.lineCap = 'round';

        contextFullReserve.moveTo(i * thickness + thickness / 2 - 300, 300);
        contextFullReserve.lineTo(i * thickness + thickness / 2, 0);
        contextFullReserve.stroke();
    }

    return contextFullReserve.createPattern(canvasFullReserve, 'repeat');
})();

const patternPartReserve = (function () {

    let color1 = "rgba(25, 153, 21, 1)", color2 = "rgba(0,0,0,0)";
    let numberOfStripes = 30;
    for (let i = 0; i < numberOfStripes * 2; i++) {
        let thickness = 300 / numberOfStripes;
        contextPartReserve.beginPath();
        contextPartReserve.strokeStyle = i % 2 ? color1 : color2;
        contextPartReserve.lineWidth = 1;
        contextPartReserve.lineCap = 'round';

        contextPartReserve.moveTo(i * thickness + thickness / 2 - 300, 0);
        contextPartReserve.lineTo(i * thickness + thickness / 2 + 300, 300);
        contextPartReserve.stroke();
    }

    return contextPartReserve.createPattern(canvasPartReserve, 'repeat');
})();

const patternAdminShutdown = (function () {

    let color1 = 'rgb(188, 0, 3)', color2 = "rgba(0,0,0,0)";
    let numberOfStripes = 40;
    for (let i = 0; i < numberOfStripes * 2; i++) {
        let thickness = 300 / numberOfStripes;
        contextAdminShutdown.beginPath();
        contextAdminShutdown.strokeStyle = i % 2 ? color1 : color2;
        contextAdminShutdown.lineWidth = 1;
        contextAdminShutdown.lineCap = 'round';

        contextAdminShutdown.moveTo(i * thickness + thickness / 2 - 300, 0);
        contextAdminShutdown.lineTo(i * thickness + thickness / 2, 300);
        contextAdminShutdown.stroke();
    }

    for (let i = 0; i < numberOfStripes * 2; i++) {
        let thickness = 300 / numberOfStripes;
        contextAdminShutdown.beginPath();
        contextAdminShutdown.strokeStyle = i % 2 ? color1 : color2;
        contextAdminShutdown.lineWidth = 1;
        contextAdminShutdown.lineCap = 'round';

        contextAdminShutdown.moveTo(i * thickness + thickness / 2 - 300, 300);
        contextAdminShutdown.lineTo(0 + i * thickness + thickness / 2, 0);
        contextAdminShutdown.stroke();
    }

    return contextAdminShutdown.createPattern(canvasAdminShutdown, 'repeat');
})();